import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=8797e5b2&scoped=true"
import script from "./LinkWidget.vue?vue&type=script&lang=js"
export * from "./LinkWidget.vue?vue&type=script&lang=js"
import style0 from "./LinkWidget.vue?vue&type=style&index=0&id=8797e5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8797e5b2",
  null
  
)

export default component.exports